import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppTranslation } from "./TranslationContext";
import './AboutUs.css';

export const About = () => {
  const navigate = useNavigate();
  const { t } = useAppTranslation();

  const [reviews, setReviews] = useState([]);

  const handleClick = () => {
    navigate('/courses');
  };

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const res = await fetch("https://api.rasulova-academy.uz/api/comment-kurs/");
        if (!res.ok) throw new Error("Ошибка загрузки комментариев");

        const data = await res.json();

        // фильтруем только с 5 звёздами и ограничиваем до 5
        const topReviews = data.filter(r => r.stars === 5).slice(0, 5);

        // получаем данные пользователей для каждого комментария
        const reviewsWithUsers = await Promise.all(
          topReviews.map(async (rev) => {
            try {
              const userRes = await fetch(`https://api.rasulova-academy.uz/api/users/${rev.user}/`);
              if (!userRes.ok) throw new Error("Ошибка загрузки пользователя");

              const userData = await userRes.json();
              return {
                ...rev,
                userName: `${userData.first_name || ''} ${userData.last_name || ''}`.trim() || userData.username
              };
            } catch {
              return { ...rev, userName: "Неизвестный пользователь" };
            }
          })
        );

        setReviews(reviewsWithUsers);
      } catch (err) {
        console.error(err);
      }
    };

    fetchReviews();
  }, []);

  return (
    <div className="about-page">

      {/* Hero-секция */}
      <div className="hero-container">
        <video autoPlay loop muted className="background-video">
          <source src="/videos/about-bg.mp4" type="video/mp4" />
          Ваш браузер не поддерживает видео.
        </video>
        <div className="video-overlay"></div>
        <div className="hero-content">
          <h1>{t('aboutTitle1')}<span><br />{t('aboutTitle2')}</span></h1>
          <p>{t('aboutSub')}</p>
          <button onClick={handleClick}>{t('footerBtn')}</button>
        </div>
      </div>

      {/* Миссия */}
      <section className="mission">
        <div className="mission-image">
          <h2>{t('mission')}</h2>
          <img src="/images/about-aim2.png" alt="" />
        </div>
        <div className="mission-content">
          <p>{t('missionText')}</p>
        </div>
      </section>

      {/* Преимущества */}
      <section className="features">
        <h2>{t('whyWe')}</h2>
        <ul className='features-list'>
          <li className='features-item'>
            <img src="/images/1.gif" alt="" />
            <span>{t('why1')}</span>
          </li>
          <li className='features-item'>
            <img src="/images/2.gif" alt="" />
            <span>{t('why2')}</span>
          </li>
          <li className='features-item'>
            <img src="/images/3.gif" alt="" />
            <span>{t('why3')}</span>
          </li>
          <li className='features-item'>
            <img src="/images/4.gif" alt="" />
            <span>{t('why4')}</span>
          </li>
        </ul>
      </section>

      {/* author */}
      <section className="author">
        <h2>{t('author')}</h2>
        <div className="author-block">
          <img src="https://api.rasulova-academy.uz/media/IMG_0952.JPG" alt="author" className="author-img" />
          <div className="author-content">
            <p className="author-name">{t('authorName')}</p>
            <p className="author-deg">{t('authoeDeg')}</p>
            <p className="author-desc">{t('authorDesc')}</p>
            <br />
            <div className="author-desc">{t('authorDesc2')}</div>
          </div>
        </div>
      </section>

      {/* Отзывы */}
      <section className="reviews">
        <h2>{t('reviews')}</h2>
        {reviews.length > 0 ? (
          reviews.map((rev) => (
            <blockquote key={rev.id}>
              {rev.comment} — <strong>{rev.userName}</strong>
            </blockquote>
          ))
        ) : (
          <p>Загрузка отзывов...</p>
        )}
      </section>
    </div>
  );
};
